export default "__VITE_ASSET__B0_esThi__"